import { q as setContext, g as getContext, b as push, s as slot, m as store_get, u as unsubscribe_stores, h as bind_props, p as pop, r as rest_props, d as spread_attributes, i as sanitize_props, n as element, e as clsx, o as spread_props, c as copy_payload, a as assign_payload, j as ensure_array_like, l as stringify, k as attr, f as escape_html } from "../../../../chunks/index2.js";
import { n as noop, i as isHTMLElement, c as omit, m as makeElement, e as executeCallbacks, d as addEventListener, a as addMeltEventListener, f as isTouch, r as removeUndefined, s as styleToString, p as portalAttr, g as effect, h as createElHelpers, k as kbd, t as tick, j as isElement, l as isDocument, q as isBrowser } from "../../../../chunks/index3.js";
import { c as createBitAttrs, I as Input, L as Label } from "../../../../chunks/label.js";
import { t as toWritableStores, o as overridable, g as generateIds, a as getPortalDestination, u as usePortal, r as removeUndefined$1, b as getOptionUpdater, c as badgeVariants } from "../../../../chunks/index5.js";
import "clsx";
import "dequal";
import { d as derived, w as writable } from "../../../../chunks/index4.js";
import { flip, offset, shift, arrow, size, autoUpdate, computePosition } from "@floating-ui/dom";
import { f as fallback } from "../../../../chunks/utils.js";
import { F as Fa } from "../../../../chunks/fa.js";
/* empty css                                                              */
import { faFileExcel, faFilter, faSearch, faCar, faSort, faBuilding, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import "../../../../chunks/index.js";
import { c as cn, f as flyAndScale, B as Button } from "../../../../chunks/button.js";
function makeHull(points) {
  const newPoints = points.slice();
  newPoints.sort(POINT_COMPARATOR);
  return makeHullPresorted(newPoints);
}
function makeHullPresorted(points) {
  if (points.length <= 1)
    return points.slice();
  const upperHull = [];
  for (let i = 0; i < points.length; i++) {
    const p = points[i];
    while (upperHull.length >= 2) {
      const q = upperHull[upperHull.length - 1];
      const r = upperHull[upperHull.length - 2];
      if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x))
        upperHull.pop();
      else
        break;
    }
    upperHull.push(p);
  }
  upperHull.pop();
  const lowerHull = [];
  for (let i = points.length - 1; i >= 0; i--) {
    const p = points[i];
    while (lowerHull.length >= 2) {
      const q = lowerHull[lowerHull.length - 1];
      const r = lowerHull[lowerHull.length - 2];
      if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x))
        lowerHull.pop();
      else
        break;
    }
    lowerHull.push(p);
  }
  lowerHull.pop();
  if (upperHull.length == 1 && lowerHull.length == 1 && upperHull[0].x == lowerHull[0].x && upperHull[0].y == lowerHull[0].y)
    return upperHull;
  else
    return upperHull.concat(lowerHull);
}
function POINT_COMPARATOR(a, b) {
  if (a.x < b.x)
    return -1;
  else if (a.x > b.x)
    return 1;
  else if (a.y < b.y)
    return -1;
  else if (a.y > b.y)
    return 1;
  else
    return 0;
}
function getPointsFromEl(el) {
  const rect = el.getBoundingClientRect();
  return [
    { x: rect.left, y: rect.top },
    { x: rect.right, y: rect.top },
    { x: rect.right, y: rect.bottom },
    { x: rect.left, y: rect.bottom }
  ];
}
function makeHullFromElements(els) {
  const points = els.flatMap((el) => getPointsFromEl(el));
  return makeHull(points);
}
function pointInPolygon(point, polygon) {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].x;
    const yi = polygon[i].y;
    const xj = polygon[j].x;
    const yj = polygon[j].y;
    const intersect = yi > point.y !== yj > point.y && point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi;
    if (intersect)
      inside = !inside;
  }
  return inside;
}
const defaultConfig = {
  strategy: "absolute",
  placement: "top",
  gutter: 5,
  flip: true,
  sameWidth: false,
  overflowPadding: 8
};
const ARROW_TRANSFORM = {
  bottom: "rotate(45deg)",
  left: "rotate(135deg)",
  top: "rotate(225deg)",
  right: "rotate(315deg)"
};
function useFloating(reference, floating, opts = {}) {
  if (!floating || !reference || opts === null)
    return {
      destroy: noop
    };
  const options = { ...defaultConfig, ...opts };
  const arrowEl = floating.querySelector("[data-arrow=true]");
  const middleware = [];
  if (options.flip) {
    middleware.push(flip({
      boundary: options.boundary,
      padding: options.overflowPadding
    }));
  }
  const arrowOffset = isHTMLElement(arrowEl) ? arrowEl.offsetHeight / 2 : 0;
  if (options.gutter || options.offset) {
    const data = options.gutter ? { mainAxis: options.gutter } : options.offset;
    if (data?.mainAxis != null) {
      data.mainAxis += arrowOffset;
    }
    middleware.push(offset(data));
  }
  middleware.push(shift({
    boundary: options.boundary,
    crossAxis: options.overlap,
    padding: options.overflowPadding
  }));
  if (arrowEl) {
    middleware.push(arrow({ element: arrowEl, padding: 8 }));
  }
  middleware.push(size({
    padding: options.overflowPadding,
    apply({ rects, availableHeight, availableWidth }) {
      if (options.sameWidth) {
        Object.assign(floating.style, {
          width: `${Math.round(rects.reference.width)}px`,
          minWidth: "unset"
        });
      }
      if (options.fitViewport) {
        Object.assign(floating.style, {
          maxWidth: `${availableWidth}px`,
          maxHeight: `${availableHeight}px`
        });
      }
    }
  }));
  function compute() {
    if (!reference || !floating)
      return;
    if (isHTMLElement(reference) && !reference.ownerDocument.documentElement.contains(reference))
      return;
    const { placement, strategy } = options;
    computePosition(reference, floating, {
      placement,
      middleware,
      strategy
    }).then((data) => {
      const x = Math.round(data.x);
      const y = Math.round(data.y);
      const [side, align] = getSideAndAlignFromPlacement(data.placement);
      floating.setAttribute("data-side", side);
      floating.setAttribute("data-align", align);
      Object.assign(floating.style, {
        position: options.strategy,
        top: `${y}px`,
        left: `${x}px`
      });
      if (isHTMLElement(arrowEl) && data.middlewareData.arrow) {
        const { x: x2, y: y2 } = data.middlewareData.arrow;
        const dir = data.placement.split("-")[0];
        arrowEl.setAttribute("data-side", dir);
        Object.assign(arrowEl.style, {
          position: "absolute",
          left: x2 != null ? `${x2}px` : "",
          top: y2 != null ? `${y2}px` : "",
          [dir]: `calc(100% - ${arrowOffset}px)`,
          transform: ARROW_TRANSFORM[dir],
          backgroundColor: "inherit",
          zIndex: "inherit"
        });
      }
      return data;
    });
  }
  Object.assign(floating.style, {
    position: options.strategy
  });
  return {
    destroy: autoUpdate(reference, floating, compute)
  };
}
function getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [side, align];
}
const defaults = {
  positioning: {
    placement: "bottom"
  },
  arrowSize: 8,
  defaultOpen: false,
  closeOnPointerDown: true,
  openDelay: 1e3,
  closeDelay: 0,
  forceVisible: false,
  portal: void 0,
  closeOnEscape: true,
  disableHoverableContent: false,
  group: void 0
};
const { name } = createElHelpers("tooltip");
const groupMap = /* @__PURE__ */ new Map();
const tooltipIdParts = ["trigger", "content"];
function createTooltip(props) {
  const withDefaults = { ...defaults, ...props };
  const options = toWritableStores(omit(withDefaults, "open", "ids"));
  const { positioning, arrowSize, closeOnPointerDown, openDelay, closeDelay, forceVisible, portal, closeOnEscape, disableHoverableContent, group } = options;
  const openWritable = withDefaults.open ?? writable(withDefaults.defaultOpen);
  const open = overridable(openWritable, withDefaults?.onOpenChange);
  const openReason = writable(null);
  const ids = toWritableStores({ ...generateIds(tooltipIdParts), ...withDefaults.ids });
  let clickedTrigger = false;
  const getEl = (part) => {
    if (!isBrowser)
      return null;
    return document.getElementById(ids[part].get());
  };
  let openTimeout = null;
  let closeTimeout = null;
  function openTooltip(reason) {
    if (closeTimeout) {
      window.clearTimeout(closeTimeout);
      closeTimeout = null;
    }
    if (!openTimeout) {
      openTimeout = window.setTimeout(() => {
        open.set(true);
        openReason.update((prev) => prev ?? reason);
        openTimeout = null;
      }, openDelay.get());
    }
  }
  function closeTooltip(isBlur) {
    if (openTimeout) {
      window.clearTimeout(openTimeout);
      openTimeout = null;
    }
    if (isBlur && isMouseInTooltipArea) {
      openReason.set("pointer");
      return;
    }
    if (!closeTimeout) {
      closeTimeout = window.setTimeout(() => {
        open.set(false);
        openReason.set(null);
        if (isBlur)
          clickedTrigger = false;
        closeTimeout = null;
      }, closeDelay.get());
    }
  }
  const isVisible = derived([open, forceVisible], ([$open, $forceVisible]) => {
    return $open || $forceVisible;
  });
  const trigger = makeElement(name("trigger"), {
    stores: [ids.content, ids.trigger, open],
    returned: ([$contentId, $triggerId, $open]) => {
      return {
        "aria-describedby": $contentId,
        id: $triggerId,
        "data-state": $open ? "open" : "closed"
      };
    },
    action: (node) => {
      const keydownHandler = (e) => {
        if (closeOnEscape.get() && e.key === kbd.ESCAPE) {
          if (openTimeout) {
            window.clearTimeout(openTimeout);
            openTimeout = null;
          }
          open.set(false);
        }
      };
      const unsub = executeCallbacks(addMeltEventListener(node, "pointerdown", () => {
        const $closeOnPointerDown = closeOnPointerDown.get();
        if (!$closeOnPointerDown)
          return;
        open.set(false);
        clickedTrigger = true;
        if (openTimeout) {
          window.clearTimeout(openTimeout);
          openTimeout = null;
        }
      }), addMeltEventListener(node, "pointerenter", (e) => {
        if (isTouch(e))
          return;
        openTooltip("pointer");
      }), addMeltEventListener(node, "pointerleave", (e) => {
        if (isTouch(e))
          return;
        if (openTimeout) {
          window.clearTimeout(openTimeout);
          openTimeout = null;
        }
      }), addMeltEventListener(node, "focus", () => {
        if (clickedTrigger)
          return;
        openTooltip("focus");
      }), addMeltEventListener(node, "blur", () => closeTooltip(true)), addMeltEventListener(node, "keydown", keydownHandler), addEventListener(document, "keydown", keydownHandler));
      return {
        destroy: unsub
      };
    }
  });
  const content = makeElement(name("content"), {
    stores: [isVisible, open, portal, ids.content],
    returned: ([$isVisible, $open, $portal, $contentId]) => {
      return removeUndefined({
        role: "tooltip",
        hidden: $isVisible ? void 0 : true,
        tabindex: -1,
        style: $isVisible ? void 0 : styleToString({ display: "none" }),
        id: $contentId,
        "data-portal": portalAttr($portal),
        "data-state": $open ? "open" : "closed"
      });
    },
    action: (node) => {
      let unsubFloating = noop;
      let unsubPortal = noop;
      const unsubDerived = effect([isVisible, positioning, portal], ([$isVisible, $positioning, $portal]) => {
        unsubPortal();
        unsubFloating();
        const triggerEl = getEl("trigger");
        if (!$isVisible || !triggerEl)
          return;
        tick().then(() => {
          unsubPortal();
          unsubFloating();
          const portalDest = getPortalDestination(node, $portal);
          if (portalDest)
            unsubPortal = usePortal(node, portalDest).destroy;
          unsubFloating = useFloating(triggerEl, node, $positioning).destroy;
        });
      });
      function handleScroll(e) {
        if (!open.get())
          return;
        const target = e.target;
        if (!isElement(target) && !isDocument(target))
          return;
        const triggerEl = getEl("trigger");
        if (triggerEl && target.contains(triggerEl)) {
          closeTooltip();
        }
      }
      const unsubEvents = executeCallbacks(addMeltEventListener(node, "pointerenter", () => openTooltip("pointer")), addMeltEventListener(node, "pointerdown", () => openTooltip("pointer")), addEventListener(window, "scroll", handleScroll, { capture: true }));
      return {
        destroy() {
          unsubEvents();
          unsubPortal();
          unsubFloating();
          unsubDerived();
        }
      };
    }
  });
  const arrow2 = makeElement(name("arrow"), {
    stores: arrowSize,
    returned: ($arrowSize) => ({
      "data-arrow": true,
      style: styleToString({
        position: "absolute",
        width: `var(--arrow-size, ${$arrowSize}px)`,
        height: `var(--arrow-size, ${$arrowSize}px)`
      })
    })
  });
  let isMouseInTooltipArea = false;
  effect(open, ($open) => {
    const currentGroup = group.get();
    if (currentGroup === void 0 || currentGroup === false) {
      return;
    }
    if (!$open) {
      if (groupMap.get(currentGroup) === open) {
        groupMap.delete(currentGroup);
      }
      return;
    }
    const currentOpen = groupMap.get(currentGroup);
    currentOpen?.set(false);
    groupMap.set(currentGroup, open);
  });
  effect([open, openReason], ([$open, $openReason]) => {
    if (!$open || !isBrowser)
      return;
    return executeCallbacks(addEventListener(document, "mousemove", (e) => {
      const contentEl = getEl("content");
      const triggerEl = getEl("trigger");
      if (!contentEl || !triggerEl)
        return;
      const polygonElements = disableHoverableContent.get() ? [triggerEl] : [triggerEl, contentEl];
      const polygon = makeHullFromElements(polygonElements);
      isMouseInTooltipArea = pointInPolygon({
        x: e.clientX,
        y: e.clientY
      }, polygon);
      if ($openReason !== "pointer")
        return;
      if (!isMouseInTooltipArea) {
        closeTooltip();
      }
    }));
  });
  return {
    ids,
    elements: {
      trigger,
      content,
      arrow: arrow2
    },
    states: { open },
    options
  };
}
function getPositioningUpdater(store) {
  return (props = {}) => {
    return updatePositioning$1(store, props);
  };
}
function updatePositioning$1(store, props) {
  const defaultPositioningProps = {
    side: "bottom",
    align: "center",
    sideOffset: 0,
    alignOffset: 0,
    sameWidth: false,
    avoidCollisions: true,
    collisionPadding: 8,
    fitViewport: false,
    strategy: "absolute",
    overlap: false
  };
  const withDefaults = { ...defaultPositioningProps, ...props };
  store.update((prev) => {
    return {
      ...prev,
      placement: joinPlacement(withDefaults.side, withDefaults.align),
      offset: {
        ...prev.offset,
        mainAxis: withDefaults.sideOffset,
        crossAxis: withDefaults.alignOffset
      },
      gutter: 0,
      sameWidth: withDefaults.sameWidth,
      flip: withDefaults.avoidCollisions,
      overflowPadding: withDefaults.collisionPadding,
      boundary: withDefaults.collisionBoundary,
      fitViewport: withDefaults.fitViewport,
      strategy: withDefaults.strategy,
      overlap: withDefaults.overlap
    };
  });
}
function joinPlacement(side, align) {
  if (align === "center")
    return side;
  return `${side}-${align}`;
}
function getTooltipData() {
  const NAME = "tooltip";
  const PARTS = ["arrow", "content", "trigger"];
  return {
    NAME,
    PARTS
  };
}
function setCtx(props) {
  const { NAME, PARTS } = getTooltipData();
  const getAttrs = createBitAttrs(NAME, PARTS);
  const tooltip = {
    ...createTooltip({
      positioning: {
        placement: "top",
        gutter: 0
      },
      openDelay: 700,
      ...removeUndefined$1(props),
      forceVisible: true
    }),
    getAttrs
  };
  setContext(NAME, tooltip);
  return {
    ...tooltip,
    updateOption: getOptionUpdater(tooltip.options)
  };
}
function getCtx() {
  const { NAME } = getTooltipData();
  return getContext(NAME);
}
function updatePositioning(props) {
  const defaultPlacement = {
    side: "top",
    align: "center",
    sideOffset: 1
  };
  const withDefaults = { ...defaultPlacement, ...props };
  const { options: { positioning } } = getCtx();
  const updater = getPositioningUpdater(positioning);
  updater({ ...withDefaults });
}
function Tooltip($$payload, $$props) {
  push();
  var $$store_subs;
  let closeOnEscape = fallback($$props["closeOnEscape"], () => void 0, true);
  let portal = fallback($$props["portal"], () => void 0, true);
  let closeOnPointerDown = fallback($$props["closeOnPointerDown"], () => void 0, true);
  let openDelay = fallback($$props["openDelay"], () => void 0, true);
  let closeDelay = fallback($$props["closeDelay"], () => void 0, true);
  let open = fallback($$props["open"], () => void 0, true);
  let onOpenChange = fallback($$props["onOpenChange"], () => void 0, true);
  let disableHoverableContent = fallback($$props["disableHoverableContent"], () => void 0, true);
  let group = fallback($$props["group"], () => void 0, true);
  const {
    states: { open: localOpen },
    updateOption,
    ids
  } = setCtx({
    closeOnEscape,
    portal,
    closeOnPointerDown,
    openDelay,
    closeDelay,
    forceVisible: true,
    defaultOpen: open,
    disableHoverableContent,
    group,
    onOpenChange: ({ next }) => {
      if (open !== next) {
        onOpenChange?.(next);
        open = next;
      }
      return next;
    },
    positioning: { gutter: 0, offset: { mainAxis: 1 } }
  });
  const idValues = derived([ids.content, ids.trigger], ([$contentId, $triggerId]) => ({ content: $contentId, trigger: $triggerId }));
  open !== void 0 && localOpen.set(open);
  updateOption("closeOnEscape", closeOnEscape);
  updateOption("portal", portal);
  updateOption("closeOnPointerDown", closeOnPointerDown);
  updateOption("openDelay", openDelay);
  updateOption("closeDelay", closeDelay);
  updateOption("group", group);
  updateOption("disableHoverableContent", disableHoverableContent);
  $$payload.out += `<!---->`;
  slot(
    $$payload,
    $$props,
    "default",
    {
      ids: store_get($$store_subs ??= {}, "$idValues", idValues)
    }
  );
  $$payload.out += `<!---->`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  bind_props($$props, {
    closeOnEscape,
    portal,
    closeOnPointerDown,
    openDelay,
    closeDelay,
    open,
    onOpenChange,
    disableHoverableContent,
    group
  });
  pop();
}
function Tooltip_content$1($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const $$restProps = rest_props($$sanitized_props, [
    "transition",
    "transitionConfig",
    "inTransition",
    "inTransitionConfig",
    "outTransition",
    "outTransitionConfig",
    "asChild",
    "id",
    "side",
    "align",
    "sideOffset",
    "alignOffset",
    "collisionPadding",
    "avoidCollisions",
    "collisionBoundary",
    "sameWidth",
    "fitViewport",
    "strategy",
    "overlap",
    "el"
  ]);
  push();
  var $$store_subs;
  let builder;
  let transition = fallback($$props["transition"], () => void 0, true);
  let transitionConfig = fallback($$props["transitionConfig"], () => void 0, true);
  let inTransition = fallback($$props["inTransition"], () => void 0, true);
  let inTransitionConfig = fallback($$props["inTransitionConfig"], () => void 0, true);
  let outTransition = fallback($$props["outTransition"], () => void 0, true);
  let outTransitionConfig = fallback($$props["outTransitionConfig"], () => void 0, true);
  let asChild = fallback($$props["asChild"], false);
  let id = fallback($$props["id"], () => void 0, true);
  let side = fallback($$props["side"], "top");
  let align = fallback($$props["align"], "center");
  let sideOffset = fallback($$props["sideOffset"], 0);
  let alignOffset = fallback($$props["alignOffset"], 0);
  let collisionPadding = fallback($$props["collisionPadding"], 8);
  let avoidCollisions = fallback($$props["avoidCollisions"], true);
  let collisionBoundary = fallback($$props["collisionBoundary"], () => void 0, true);
  let sameWidth = fallback($$props["sameWidth"], false);
  let fitViewport = fallback($$props["fitViewport"], false);
  let strategy = fallback($$props["strategy"], "absolute");
  let overlap = fallback($$props["overlap"], false);
  let el = fallback($$props["el"], () => void 0, true);
  const {
    elements: { content },
    states: { open },
    ids,
    getAttrs
  } = getCtx();
  const attrs = getAttrs("content");
  if (id) {
    ids.content.set(id);
  }
  builder = store_get($$store_subs ??= {}, "$content", content);
  Object.assign(builder, attrs);
  if (store_get($$store_subs ??= {}, "$open", open)) {
    updatePositioning({
      side,
      align,
      sideOffset,
      alignOffset,
      collisionPadding,
      avoidCollisions,
      collisionBoundary,
      sameWidth,
      fitViewport,
      strategy,
      overlap
    });
  }
  if (asChild && store_get($$store_subs ??= {}, "$open", open)) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<!---->`;
    slot($$payload, $$props, "default", { builder });
    $$payload.out += `<!---->`;
  } else {
    $$payload.out += "<!--[!-->";
    if (transition && store_get($$store_subs ??= {}, "$open", open)) {
      $$payload.out += "<!--[-->";
      $$payload.out += `<div${spread_attributes({ ...builder, ...$$restProps })}><!---->`;
      slot($$payload, $$props, "default", { builder });
      $$payload.out += `<!----></div>`;
    } else {
      $$payload.out += "<!--[!-->";
      if (inTransition && outTransition && store_get($$store_subs ??= {}, "$open", open)) {
        $$payload.out += "<!--[-->";
        $$payload.out += `<div${spread_attributes({ ...builder, ...$$restProps })}><!---->`;
        slot($$payload, $$props, "default", { builder });
        $$payload.out += `<!----></div>`;
      } else {
        $$payload.out += "<!--[!-->";
        if (inTransition && store_get($$store_subs ??= {}, "$open", open)) {
          $$payload.out += "<!--[-->";
          $$payload.out += `<div${spread_attributes({ ...builder, ...$$restProps })}><!---->`;
          slot($$payload, $$props, "default", { builder });
          $$payload.out += `<!----></div>`;
        } else {
          $$payload.out += "<!--[!-->";
          if (outTransition && store_get($$store_subs ??= {}, "$open", open)) {
            $$payload.out += "<!--[-->";
            $$payload.out += `<div${spread_attributes({ ...builder, ...$$restProps })}><!---->`;
            slot($$payload, $$props, "default", { builder });
            $$payload.out += `<!----></div>`;
          } else {
            $$payload.out += "<!--[!-->";
            if (store_get($$store_subs ??= {}, "$open", open)) {
              $$payload.out += "<!--[-->";
              $$payload.out += `<div${spread_attributes({ ...builder, ...$$restProps })}><!---->`;
              slot($$payload, $$props, "default", { builder });
              $$payload.out += `<!----></div>`;
            } else {
              $$payload.out += "<!--[!-->";
            }
            $$payload.out += `<!--]-->`;
          }
          $$payload.out += `<!--]-->`;
        }
        $$payload.out += `<!--]-->`;
      }
      $$payload.out += `<!--]-->`;
    }
    $$payload.out += `<!--]-->`;
  }
  $$payload.out += `<!--]-->`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  bind_props($$props, {
    transition,
    transitionConfig,
    inTransition,
    inTransitionConfig,
    outTransition,
    outTransitionConfig,
    asChild,
    id,
    side,
    align,
    sideOffset,
    alignOffset,
    collisionPadding,
    avoidCollisions,
    collisionBoundary,
    sameWidth,
    fitViewport,
    strategy,
    overlap,
    el
  });
  pop();
}
function Tooltip_trigger($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const $$restProps = rest_props($$sanitized_props, ["asChild", "id", "el"]);
  push();
  var $$store_subs;
  let builder;
  let asChild = fallback($$props["asChild"], false);
  let id = fallback($$props["id"], () => void 0, true);
  let el = fallback($$props["el"], () => void 0, true);
  const { elements: { trigger }, ids, getAttrs } = getCtx();
  const attrs = getAttrs("trigger");
  if (id) {
    ids.trigger.set(id);
  }
  builder = store_get($$store_subs ??= {}, "$trigger", trigger);
  Object.assign(builder, attrs);
  if (asChild) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<!---->`;
    slot($$payload, $$props, "default", { builder });
    $$payload.out += `<!---->`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<button${spread_attributes({ ...builder, type: "button", ...$$restProps })}><!---->`;
    slot($$payload, $$props, "default", { builder });
    $$payload.out += `<!----></button>`;
  }
  $$payload.out += `<!--]-->`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  bind_props($$props, { asChild, id, el });
  pop();
}
function Badge($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const $$restProps = rest_props($$sanitized_props, ["class", "href", "variant"]);
  push();
  let className = fallback($$props["class"], void 0);
  let href = fallback($$props["href"], void 0);
  let variant = fallback($$props["variant"], "default");
  element(
    $$payload,
    href ? "a" : "span",
    () => {
      $$payload.out += `${spread_attributes({
        href,
        class: clsx(cn(badgeVariants({ variant, className }))),
        ...$$restProps
      })}`;
    },
    () => {
      $$payload.out += `<!---->`;
      slot($$payload, $$props, "default", {});
      $$payload.out += `<!---->`;
    }
  );
  bind_props($$props, { class: className, href, variant });
  pop();
}
function Tooltip_content($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const $$restProps = rest_props($$sanitized_props, [
    "class",
    "sideOffset",
    "transition",
    "transitionConfig"
  ]);
  push();
  let className = fallback($$props["class"], void 0);
  let sideOffset = fallback($$props["sideOffset"], 4);
  let transition = fallback($$props["transition"], flyAndScale);
  let transitionConfig = fallback($$props["transitionConfig"], () => ({ y: 8, duration: 150 }), true);
  Tooltip_content$1($$payload, spread_props([
    {
      transition,
      transitionConfig,
      sideOffset,
      class: cn("bg-primary text-primary-foreground z-50 overflow-hidden rounded-md px-3 py-1.5 text-xs", className)
    },
    $$restProps,
    {
      children: ($$payload2) => {
        $$payload2.out += `<!---->`;
        slot($$payload2, $$props, "default", {});
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, {
    class: className,
    sideOffset,
    transition,
    transitionConfig
  });
  pop();
}
const Root = Tooltip;
const Trigger = Tooltip_trigger;
function _page($$payload, $$props) {
  push();
  let filteredResponses;
  let formIdMapping = {};
  let questions = [];
  let selectedDepartment = "all";
  let responses = [];
  let clients = [];
  let brands = [];
  const loadQuestions = async () => {
    {
      const [salesResponse, serviceResponse] = await Promise.all([
        fetch(`/api/questions?formId=${formIdMapping["sales"]}`),
        fetch(`/api/questions?formId=${formIdMapping["service"]}`)
      ]);
      const [salesQuestions, serviceQuestions] = await Promise.all([
        salesResponse.json(),
        serviceResponse.json()
      ]);
      questions = [...salesQuestions, ...serviceQuestions];
      questions.length;
      questions.filter((q) => q.type === "rating");
      questions.filter((q) => q.type === "comment");
    }
  };
  loadQuestions();
  let searchQuery = "";
  let selectedBrands = [];
  let selectedIpAddresses = [];
  let selectedRatings = [];
  const ratingLabels = {
    1: {
      text: "Shumë keq",
      color: "bg-red-500",
      hoverColor: "hover:bg-red-600",
      borderColor: "hover:border-red-500"
    },
    2: {
      text: "Keq",
      color: "bg-orange-500",
      hoverColor: "hover:bg-orange-600",
      borderColor: "hover:border-orange-500"
    },
    3: {
      text: "Mirë",
      color: "bg-yellow-500",
      hoverColor: "hover:bg-yellow-600",
      borderColor: "hover:border-yellow-500"
    },
    4: {
      text: "Shumë mirë",
      color: "bg-lime-500",
      hoverColor: "hover:bg-lime-600",
      borderColor: "hover:border-lime-500"
    },
    5: {
      text: "Shkëlqyeshëm",
      color: "bg-green-500",
      hoverColor: "hover:bg-green-600",
      borderColor: "hover:border-green-500"
    }
  };
  function formatDate(dateStr) {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const months = [
      "Janar",
      "Shkurt",
      "Mars",
      "Prill",
      "Maj",
      "Qershor",
      "Korrik",
      "Gusht",
      "Shtator",
      "Tetor",
      "Nëntor",
      "Dhjetor"
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  }
  filteredResponses = responses.filter((response) => {
    console.groupCollapsed("Filtering response");
    console.log("response:", response);
    if (searchQuery) {
      const query = searchQuery.toLowerCase().split(/\s+/);
      const searchMatch = (response2) => query.every((q) => [
        clients.find((c) => c.id === response2.clientId)?.username.toLowerCase(),
        questions.find((q2) => q2.id === response2.questionId)?.formId === formIdMapping[selectedDepartment] ? selectedDepartment : "",
        brands.find((b) => b.id === response2.brandId)?.name.toLowerCase(),
        formatDate(new Date(response2.createdAt)).toLowerCase()
      ].some((value) => value.includes(q)));
      console.log("search query:", query);
      console.log("search match:", searchMatch(response));
      if (!searchMatch(response)) {
        console.log("filtered out due to search");
        console.groupEnd();
        return false;
      }
    }
    if (selectedBrands.length > 0 && !selectedBrands.some((b) => b.id === response.brandId)) {
      console.log("filtered out due to brand");
      console.groupEnd();
      return false;
    }
    if (selectedRatings.length > 0 && !selectedRatings.some((r) => r === parseInt(response.value))) {
      console.log("filtered out due to rating");
      console.groupEnd();
      return false;
    }
    console.groupEnd();
    return true;
  });
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    const each_array = ensure_array_like(brands);
    const each_array_1 = ensure_array_like([1, 2, 3, 4, 5]);
    const each_array_2 = ensure_array_like(questions);
    const each_array_3 = ensure_array_like(clients);
    $$payload2.out += `<div class="h-[calc(100vh-4.8rem)] flex flex-col bg-[#111111] overflow-hidden"><div class="flex-none p-4"><div class="flex items-center justify-between"><h1 class="text-2xl font-bold text-white">Tabela e Feedback-ut</h1> <div class="flex gap-2">`;
    Button($$payload2, {
      variant: "default",
      class: "border-[#ff6b00] bg-[#ff6b00] text-black hover:bg-[#ff6b00a2] hover:text-white",
      children: ($$payload3) => {
        Fa($$payload3, { icon: faFileExcel, class: "mr-2 h-4 w-4" });
        $$payload3.out += `<!----> Export`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----></div></div></div> <div class="flex-1 min-h-0 flex"><div class="w-64 flex-none h-full pr-4 overflow-y-auto"><div class="p-6 space-y-6"><div class="flex items-center justify-between"><span class="text-lg font-semibold text-white flex items-center gap-2">`;
    Fa($$payload2, { icon: faFilter, class: "text-[#ff6b00]" });
    $$payload2.out += `<!----> Filtrat</span> `;
    if (searchQuery || selectedBrands.length > 0 || selectedIpAddresses.length > 0 || selectedRatings.length > 0) {
      $$payload2.out += "<!--[-->";
      Button($$payload2, {
        variant: "ghost",
        size: "sm",
        class: "text-[#ff6b00] hover:text-[#ff6b00]/80",
        children: ($$payload3) => {
          $$payload3.out += `<!---->Pastro Filtrat`;
        },
        $$slots: { default: true }
      });
    } else {
      $$payload2.out += "<!--[!-->";
    }
    $$payload2.out += `<!--]--></div> <div class="relative">`;
    Fa($$payload2, {
      icon: faSearch,
      class: "absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
    });
    $$payload2.out += `<!----> `;
    Input($$payload2, {
      type: "text",
      placeholder: "Search...",
      class: "pl-10 bg-[#111111] border-white/20 focus:border-[#ff6b00] text-white placeholder-gray-500",
      get value() {
        return searchQuery;
      },
      set value($$value) {
        searchQuery = $$value;
        $$settled = false;
      }
    });
    $$payload2.out += `<!----></div> <div class="space-y-2">`;
    Label($$payload2, {
      class: "text-sm font-medium flex items-center gap-2 text-gray-300",
      children: ($$payload3) => {
        Fa($$payload3, { icon: faCar, class: "text-[#ff6b00]" });
        $$payload3.out += `<!----> Marka`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> <div class="flex flex-wrap gap-2"><!--[-->`;
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let brand = each_array[$$index];
      $$payload2.out += `<button class="group">`;
      Badge($$payload2, {
        variant: selectedBrands.includes(brand) ? "default" : "outline",
        class: `${stringify(selectedBrands.includes(brand) ? "bg-[#ff6b00] hover:bg-[#ff6b00]/90" : "")} border border-white/20 hover:border-[#ff6b00] hover:text-white rounded-lg p-3 flex-col items-center gap-1`,
        children: ($$payload3) => {
          $$payload3.out += `<img${attr("src", brand.imageUrl)}${attr("alt", brand.name)} class="w-16 h-16 rounded-full invert"> <span class="font-medium text-white">${escape_html(brand.name)}</span>`;
        },
        $$slots: { default: true }
      });
      $$payload2.out += `<!----></button>`;
    }
    $$payload2.out += `<!--]--></div></div>  <div class="space-y-4">`;
    Label($$payload2, {
      class: "text-lg font-semibold text-white flex items-center gap-2",
      children: ($$payload3) => {
        Fa($$payload3, { icon: faSort, class: "text-[#ff6b00]" });
        $$payload3.out += `<!----> Pergjigja`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> <div class="flex flex-wrap gap-2"><!--[-->`;
    for (let $$index_1 = 0, $$length = each_array_1.length; $$index_1 < $$length; $$index_1++) {
      let rating = each_array_1[$$index_1];
      $$payload2.out += `<button>`;
      Badge($$payload2, {
        variant: selectedRatings.includes(rating) ? "default" : "outline",
        class: `${stringify(selectedRatings.includes(rating) ? `${ratingLabels[rating].color} text-white ${ratingLabels[rating].hoverColor}` : `border-2 border-white/20 ${ratingLabels[rating].borderColor} hover:text-white`)} rounded-lg px-3 py-2 transition-colors`,
        children: ($$payload3) => {
          $$payload3.out += `<!---->${escape_html(ratingLabels[rating].text)}`;
        },
        $$slots: { default: true }
      });
      $$payload2.out += `<!----></button>`;
    }
    $$payload2.out += `<!--]--></div></div></div></div> <div class="flex-1 flex flex-col min-w-0 bg-[#1a1a1a] rounded-lg border border-white/10"><div class="flex-none p-4 border-b border-white/10"><div class="flex items-center justify-between"><div class="flex items-center gap-4">`;
    Label($$payload2, {
      class: "text-sm font-medium flex items-center gap-2 text-gray-300",
      children: ($$payload3) => {
        Fa($$payload3, { icon: faBuilding, class: "text-[#ff6b00]" });
        $$payload3.out += `<!----> Departamenti`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> <div class="flex flex-wrap gap-2">`;
    Button($$payload2, {
      variant: "default",
      class: "bg-[#ff6b00] hover:bg-[#ff6b00]/90",
      children: ($$payload3) => {
        $$payload3.out += `<!---->Te gjitha`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> `;
    Button($$payload2, {
      variant: "outline",
      class: "border border-white/20 hover:border-[#ff6b00] hover:text-white",
      children: ($$payload3) => {
        $$payload3.out += `<!---->Shitje`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> `;
    Button($$payload2, {
      variant: "outline",
      class: "border border-white/20 hover:border-[#ff6b00] hover:text-white",
      children: ($$payload3) => {
        $$payload3.out += `<!---->Servis`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----></div></div></div></div> <div class="flex-1 min-h-0 relative"><div class="absolute inset-0 overflow-auto svelte-1lucu9p"><table class="w-full border-collapse min-w-[800px]"><thead class="sticky top-0 z-20 bg-[#1a1a1a]"><tr><th class="sticky left-0 z-20 bg-[#1a1a1a] px-4 py-2 text-left font-medium text-gray-300 border-b border-white/10">Data</th><th class="sticky left-[120px] z-20 bg-[#1a1a1a] px-4 py-2 text-left font-medium text-gray-300 border-b border-white/10">Emri</th><th class="sticky left-[280px] z-20 bg-[#1a1a1a] px-4 py-2 text-left font-medium text-gray-300 border-b border-white/10">Marka</th><!--[-->`;
    for (let i = 0, $$length = each_array_2.length; i < $$length; i++) {
      let question = each_array_2[i];
      $$payload2.out += `<th class="px-4 py-2 border-l border-r text-left font-medium text-gray-300 border-b border-white/10 whitespace-nowrap">`;
      Root($$payload2, {
        children: ($$payload3) => {
          Trigger($$payload3, {
            children: ($$payload4) => {
              $$payload4.out += `<span class="hover:text-[#ff6b00] transition-colors">Q${escape_html(i + 1)}</span>`;
            },
            $$slots: { default: true }
          });
          $$payload3.out += `<!----> `;
          Tooltip_content($$payload3, {
            children: ($$payload4) => {
              $$payload4.out += `<!---->${escape_html(question.text)}`;
            },
            $$slots: { default: true }
          });
          $$payload3.out += `<!---->`;
        },
        $$slots: { default: true }
      });
      $$payload2.out += `<!----></th>`;
    }
    $$payload2.out += `<!--]--></tr></thead><tbody><!--[-->`;
    for (let $$index_5 = 0, $$length = each_array_3.length; $$index_5 < $$length; $$index_5++) {
      let client = each_array_3[$$index_5];
      if (filteredResponses.some((response) => response.clientId === client.id)) {
        $$payload2.out += "<!--[-->";
        const each_array_4 = ensure_array_like(questions);
        $$payload2.out += `<tr class="border-b border-white/20 hover:bg-[#222222] transition-colors group overflow-x-auto"><td class="sticky left-0 z-10 bg-[#111111] group-hover:bg-[#1a1a1a] px-4 py-2 border-b border-white/10 svelte-1lucu9p">${escape_html(formatDate(filteredResponses.find((response) => response.clientId === client.id).createdAt))}</td><td class="sticky left-[120px] z-10 bg-[#111111] group-hover:bg-[#1a1a1a] px-4 py-2 border-b border-white/10 svelte-1lucu9p">${escape_html(client.username)}</td><td class="sticky left-[280px] z-10 bg-[#111111] group-hover:bg-[#1a1a1a] px-4 py-2 border-b border-white/10 svelte-1lucu9p"><div class="flex items-center gap-2"><img${attr("src", (brands.find((b) => b.id === filteredResponses.find((response) => response.clientId === client.id).brandId) || {}).imageUrl)}${attr("alt", (brands.find((b) => b.id === filteredResponses.find((response) => response.clientId === client.id).brandId) || {}).name || "Brand Image")} class="w-10 h-10 mr-2 object-contain invert"> ${escape_html((brands.find((b) => b.id === filteredResponses.find((response) => response.clientId === client.id).brandId) || {}).name)}</div></td><!--[-->`;
        for (let $$index_4 = 0, $$length2 = each_array_4.length; $$index_4 < $$length2; $$index_4++) {
          let question = each_array_4[$$index_4];
          $$payload2.out += `<td class="border-b border-l border-r border-white/10 px-4 py-2 text-center align-middle overflow-x-auto svelte-1lucu9p">`;
          if (filteredResponses.some((response) => response.clientId === client.id && response.questionId === question.id)) {
            $$payload2.out += "<!--[-->";
            const each_array_5 = ensure_array_like(filteredResponses.filter((response) => response.questionId === question.id && [1, 2, 3, 4, 5].includes(parseInt(response.value))));
            if (each_array_5.length !== 0) {
              $$payload2.out += "<!--[-->";
              for (let j = 0, $$length3 = each_array_5.length; j < $$length3; j++) {
                let response = each_array_5[j];
                Badge($$payload2, {
                  class: `${ratingLabels[parseInt(response.value)].color} mx-auto`,
                  children: ($$payload3) => {
                    $$payload3.out += `<!---->${escape_html(ratingLabels[parseInt(response.value)].text)}`;
                  },
                  $$slots: { default: true }
                });
              }
            } else {
              $$payload2.out += "<!--[!-->";
              $$payload2.out += `<textarea class="text-gray-300 h-[4rem] bg-transparent border-0 overflow-y-auto resize-none"${attr("rows", 3)}>`;
              const $$body = escape_html(filteredResponses.find((response) => response.clientId === client.id && response.questionId === question.id)?.value || "-");
              if ($$body) {
                $$payload2.out += `${$$body}`;
              }
              $$payload2.out += `</textarea>`;
            }
            $$payload2.out += `<!--]-->`;
          } else {
            $$payload2.out += "<!--[!-->";
            $$payload2.out += `<div class="h-[4rem] flex items-center justify-center">`;
            Fa($$payload2, { icon: faCircleXmark, class: "text-gray-300" });
            $$payload2.out += `<!----></div>`;
          }
          $$payload2.out += `<!--]--></td>`;
        }
        $$payload2.out += `<!--]--></tr>`;
      } else {
        $$payload2.out += "<!--[!-->";
      }
      $$payload2.out += `<!--]-->`;
    }
    $$payload2.out += `<!--]--></tbody></table></div></div></div></div></div>`;
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  pop();
}
export {
  _page as default
};
